export const currencies = ["EUR", "GBP", "USD"];

export const getValidCurrency = (currency = "") => {
  if (currency && currencies.includes(currency.toUpperCase())) {
    return currency.toUpperCase();
  } else {
    return "EUR";
  }
};
